import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UpdateApplicantForm from './Pages/UpdateApplicantsForm';  // Import the form

const UpdateApplicantApp = () => {
  return (
    <Router>
      <Routes>
        <Route path="/update-applicant" element={<UpdateApplicantForm />} />
        {/* Add a fallback route or any additional routes specific to UpdateApplicantForm */}
        <Route path="*" element={<UpdateApplicantForm />} />
      </Routes>
    </Router>
  );
};

export default UpdateApplicantApp;
